import { buildScopedI18n } from '../../../../../utils/buildScopedI18n';
import configServiceEsCL from './locales/es-CL.json';
import configServiceEnUS from './locales/en-US.json';
import configServicePtBR from './locales/pt-BR.json';

export const configServiceI18n = buildScopedI18n({
  esCL: configServiceEsCL,
  enUS: configServiceEnUS,
  ptBR: configServicePtBR,
});
